module.exports = __webpack_public_path__ + "img/welcome-icon-03.2f47cbc9.png";